export const EMAIL_CONFIG_RULES = {
  maxFilesSize: parseInt(
    process.env.REACT_APP_GMAIL_MAX_FILES_SIZE ||
    "25"
  ),
};
